export default {
  default: {
    assigned: {
      one: 'Other',
      many: 'Others',
    },
  },
}
